import { useState } from 'react'
import { DeleteBookmark, PostBookmark } from '@/api/bookmark'
import { PostFavorite } from '@/api/favorite'
import { initialStyles, Modal } from '@/components/modal/Modal'
import { BookmarkButton } from '.'

const modalStyle = {
  ...initialStyles,
  content: {
    ...initialStyles.content,
    textAlign: 'center',
  },
}

interface Props {
  summaryId: number
  bookmark: boolean
  favorite: boolean
}
export const BookmarkButtons: React.FC<Props> = ({
  summaryId,
  bookmark,
  favorite,
}) => {
  const [isBookmark, setIsBookmark] = useState(bookmark)
  const [isFavorite, setIsFavorite] = useState(favorite)
  const [modalOpen, setModalOpen] = useState(false)

  const onBookmarkClick = async (nowStatus: boolean) => {
    if (nowStatus) {
      // あとで読むを解除
      const res = await DeleteBookmark(summaryId)
      if (res.error || !res.result) {
        setModalOpen(true)
        return
      }
      setIsBookmark(false)
    } else {
      // あとで読む
      const res = await PostBookmark(summaryId)
      if (res.error || !res.result) {
        setModalOpen(true)
        return
      }
      setIsBookmark(true)
    }
  }
  const onFavoriteClick = async (nowStatus: boolean) => {
    // お気に入りの状態を更新
    const nextStatus = !nowStatus
    const res = await PostFavorite(summaryId, nextStatus)
    if (res.error || !res.result) {
      setModalOpen(true)
      return
    }
    setIsFavorite(nextStatus)
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        style={modalStyle}
      >
        <div className="p-4">
          <div className="pb-8">
            通信に失敗しました。時間をおいて改めてお試しください。
          </div>
          <button
            onClick={() => setModalOpen(false)}
            className="py-2 px-3 text-sm text-white bg-fl-blue rounded"
          >
            閉じる
          </button>
        </div>
      </Modal>
      <div className="mt-[10px] mb-[15px]">
        <BookmarkButton
          text={isBookmark ? 'あとで読むを解除' : 'あとで読む'}
          className={
            isBookmark ? 'bg-[#eef2fb] border-[#1d6dcc] text-[#1d6dcc]' : ''
          }
          onClick={() => onBookmarkClick(isBookmark)}
        />
      </div>
      <div className="mb-[10px]">
        <BookmarkButton
          text={isFavorite ? 'お気に入りから外す' : 'お気に入りに登録'}
          className={
            isFavorite ? 'bg-[#eef2fb] border-[#1d6dcc] text-[#1d6dcc]' : ''
          }
          onClick={() => onFavoriteClick(isFavorite)}
        />
      </div>
    </>
  )
}
